var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-layout__list main-layout__list_mxh80"},[_c('administrators-list-head'),_vm._l((_vm.administrators),function(item,index){return _c('administrators-list-item',{key:index,attrs:{"item":item,"index":index + 1}})})],2)}
var staticRenderFns = []

export { render, staticRenderFns }